<template>
  <div class="footer-main">
    <div class="container col">
      <div class="row">
        <div class="col s12 xl3">
          <div class="footerMain row pt-4">
            <div class="col s12 m6 xl12">
              <NuxtLink
                to="/"
                :aria-label="confMain.siteDescr"
                class="logo"
              >
                <img
                  :alt="confMain.siteDescr"
                  src="/img/logo-slogan.svg"
                  class="responsive-img"
                />
              </NuxtLink>

              <HelpersSocials />
            </div>

            <div class="footerMain__reviews col s12 m6 xl12">
              <HelpersReviews />
            </div>
          </div>
        </div>
        <div class="col s12 xl9">
          <FooterNavigation />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { confMain } = useConfig()
</script>

<style lang="scss" scoped>
.page-footer {
  .footer-main {
    padding: 35px 0 40px;
    .footerMain {
      margin-bottom: 38px;
      @media only screen and (max-width: 600px) {
        text-align: center;
      }
      .logo {
        img {
          width: 205px;
          height: 55px;
        }
      }
      .socials {
        padding-top: 20px;
        @media only screen and (max-width: 600px) {
          justify-content: center;
        }
      }
      &__reviews {
        &:deep(.reviewsBlock) {
          a {
            @media only screen and (min-width: 1441px) {
              justify-content: inherit;
            }
            @media only screen and (max-width: 600px) {
              justify-content: center;
            }
          }
        }
      }
    }
  }
}
</style>
